module.exports = __webpack_public_path__ + "img/511344f3a63b46a4d201adf38fabe1c7.svg";